module.exports = "/_next/static/images/placeholder-3f3427fc77bbbb9fed8e6c4721296db6.jpg";